export default {
    animation: Boolean | Object,
    autoBind: Boolean,
    autoWidth: Boolean,
    cascadeFrom: String,
    cascadeFromField: String,
    dataSource: Object | Array,
    dataTextField: String,
    dataValueField: String,
    delay: Number,
    enable: Boolean,
    enforceMinLength: Boolean,
    filter: String,
    fixedGroupTemplate: String | Function,
    footerTemplate: String | Function,
    groupTemplate: String | Function,
    height: Number,
    ignoreCase: Boolean,
    index: Number,
    minLength: Number,
    noDataTemplate: String | Function,
    popup: Object,
    optionLabel: String | Object,
    optionLabelTemplate: String | Function,
    headerTemplate: String | Function,
    template: String | Function,
    valueTemplate: String | Function,
    text: String,
    value: String | Number,
    valuePrimitive: Boolean,
    virtual: Boolean | Object,

    // Events
    change: Function,
    close: Function,
    dataBound: Function,
    filtering: Function,
    open: Function,
    select: Function,
    cascade: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoDropDownList/DropDownListProps.js